import styled from '@emotion/styled'
import { css } from '@emotion/react'
import theme from '../../../styles/theme'
import {
  InfoSmall600Style,
  InfoExtraSmall600Style,
} from '../../../styles/Text.styles'
import { scrollbarStyle } from '../../../styles/Scrollbar.styles'
// Import from new location instead of defining here
import AIPlusBadge from '../AIPlusBadge'

// Re-export AIPlusBadge for backward compatibility
export { AIPlusBadge }

// Interfaces for styled component props
interface SizeProps {
  size?: 'small' | 'big'
}

interface ShowProps {
  show?: boolean
}

interface WideProps {
  wide?: boolean
}

interface OverwriteMessageProps {
  isModal?: boolean
  wide?: boolean
}

export const outerContainerSyle = css`
  padding: 1.5rem 0.5rem 1.5rem 0.5rem;
  background-color: ${theme.colors.surface};
  outline: 2px solid ${theme.colors.backgroundMediumDark};
  border-radius: 1.6rem;
  min-width: 10rem; // Minimum width for all cases
  position: relative;
`

export const dottedBottomBorder = css`
  border-bottom-width: 2px;
  border-bottom-style: dotted;
  border-bottom-color: ${theme.colors.backgroundDark};
`

export const OuterContainer = styled.div<SizeProps>`
  ${outerContainerSyle};
  ${(props) => {
    switch (props.size) {
      case 'small':
        return 'width: 22rem;'
      case 'big':
        return 'width: 40rem;'
      default:
        return 'width: 100%;' // Allow container to grow and fill available space
    }
  }}
`

export const WideModeOuterContainer = styled.div`
  ${outerContainerSyle};
  width: 72rem;
  margin-bottom: 0.6rem;
`

export const Container = styled.div`
  position: relative;
`

export const WideModeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0rem;
`

export const WideModeSplitter = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  box-sizing: border-box;
`

export const WideModeExtraHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  box-sizing: border-box;
`

export const GradientContainer = styled.div<ShowProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6rem;
  background: linear-gradient(
    rgba(245, 245, 245, 0) 0%,
    #ffffff88 50%,
    #ffffffc7 100%
  );
  backdrop-filter: blur(0.05rem);
  border-radius: 0rem 0rem 1.2rem 1.2rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;

  ${(props) =>
    props.show &&
    `
        opacity: 1;
        visibility: visible;
    `}
`

export const HeaderContainer = styled.div<WideProps>`
  ${dottedBottomBorder};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.wide ? '0.4rem' : '1rem')};
  height: 2rem;

  padding-bottom: 0.5rem;
`

export const HeaderTitle = styled.span`
  ${InfoSmall600Style};
  color: ${theme.colors.veryVeryVeryFadedText};
  margin-left: 0.5rem;
`

export const Toolbox = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: relative;
  z-index: 10; // Higher than Plotly's modebar which is typically 999
  > * {
    cursor: pointer;
  }
`

export const PlotArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  min-height: 20rem;
  overflow: hidden;
  max-height: 21rem;
  ${scrollbarStyle}
`

export const GraphPlotArea = styled.div<WideProps>`
  ${(props) => !props.wide && dottedBottomBorder};

  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;

  ${scrollbarStyle}
`

export const Footer = styled.div`
  margin-top: 1rem;
  color: ${theme.colors.veryFadedText};
  font-size: 0.85rem;
`

export const CheckboxContainer = styled.div<WideProps>`
  display: flex;
  gap: 2rem;
  flex-direction: row;
  margin-bottom: ${(props) => (props.wide ? '0rem' : '0.0rem;')};
  margin-top: ${(props) => (props.wide ? '0.4rem' : '0.6rem;')};
  align-items: center;
  justify-content: flex-end;
  margin-right: 1rem;
`

export const AIHStack = styled.div`
  display: flex;
  gap: 5rem;
  flex-direction: row;
  padding-right: 6rem;
  padding-left: 6rem;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  > * {
    flex: 1;
  }
`

export const AICheckboxAndContainer = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;

  gap: 0.5rem;
  flex: 1;
  max-width: 60rem;
`

export const ModalCheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.5rem;
  gap: 0.5rem;
  width: 100%;
`

// New styled component for the overwrite message
export const OverwriteMessageContainer = styled.div<OverwriteMessageProps>`
  ${InfoExtraSmall600Style};
  width: ${(props) => (props.isModal ? '100%' : props.wide ? '93%' : '100%')};
  height: ${(props) =>
    props.isModal ? '100%' : props.wide ? '27rem' : '22rem'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.backgroundVeryDark};
  text-align: center;
  padding: ${(props) => (props.isModal ? '20px' : '0.5rem')};
`
